module.exports = __webpack_public_path__ + "static/media/default-fallback.f4a3ad50.svg";